<template>
  <label :name="name" class="default" :class="classNames">
    <input class="input" type="checkbox" @click.stop="onChecked" />
    <img class="image" :src="image" alt="check-image" />
    <slot></slot>
  </label>
</template>

<script>
import Disable from '@/assets/images/checkbox_disable.svg'
import Off from '@/assets/images/checkbox_off.svg'
import On from '@/assets/images/checkbox_on.svg'

export default {
  name: 'VCheckBox',
  props: {
    name: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      required: true
    },
    onChecked: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classNames() {
      return { active: this.checked, disabled: this.disabled }
    },
    image() {
      return this.disabled ? Disable : this.checked ? On : Off
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.default {
  display: block;
  font-size: 18px;
  position: relative;
  padding-left: 30px;
  padding-right: 16px;
  letter-spacing: -0.3px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  cursor: pointer;

  & .image {
    position: absolute;
    left: 0;
    top: 0;
    margin: 1px;
    width: 24px;
    height: 24px;
    border-radius: 2px;
    z-index: 1;
  }
}
</style>